import React from "react"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { LiteSlateEditor } from "../../lite-slate-editor"
import { getRatio } from "../../components/column-ratio"
import { ConditionalLink } from "../../../shared/conditional-link"

const DEFAULT_IMAGE_URL =
  "https://cdn.convertkit.com/assets/layout-placeholder-v2.png"

const styles = `
  @media only screen and (max-width:600px) {
    .ck-roundImageLeftCopyRight td {
      display: block !important;
      width: 100% !important;
      padding: 0 !important;
    }
    .ck-roundImageLeftCopyRight td:first-of-type {
      padding-bottom: 18px !important;
    }
    .circleImage {
      margin: auto !important;
    }
  }
`

export function RoundImageLeftCopyRight({ block_id, properties }) {
  const { children } = useBlocks(block_id)

  const containerStyle = {
    backgroundColor: properties.backgroundColor,
    paddingTop: properties.paddingTop,
    paddingRight: properties.paddingRight,
    paddingBottom: properties.paddingBottom,
    paddingLeft: properties.paddingLeft,
    borderTopLeftRadius: properties.borderTopLeftRadius,
    borderTopRightRadius: properties.borderTopRightRadius,
    borderBottomLeftRadius: properties.borderBottomLeftRadius,
    borderBottomRightRadius: properties.borderBottomRightRadius,
    borderWidth: properties.borderWidth,
    borderTopWidth: properties.borderTopWidth,
    borderRightWidth: properties.borderRightWidth,
    borderBottomWidth: properties.borderBottomWidth,
    borderLeftWidth: properties.borderLeftWidth,
    borderColor: properties.borderColor,
    borderStyle: "solid"
  }

  return (
    <div
      className="ck-roundImageLeftCopyRight ck-layout-block-template"
      style={containerStyle}
      bgcolor={properties.backgroundColor}
    >
      <table
        border="0"
        cellPadding="0"
        cellSpacing="0"
        width="100%"
        bgcolor={properties.backgroundColor}
      >
        <tbody>
          <tr>
            <td
              width={getRatio(properties.columnRatio, "left")}
              style={{ paddingRight: 30 }}
            >
              <ConditionalLink href={properties.imageUrl}>
                <div
                  className="circleImage"
                  style={{
                    height: 200,
                    width: 200,
                    backgroundImage: `url(${properties.image ||
                      DEFAULT_IMAGE_URL})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: 999999999,
                    overflow: "hidden",
                    verticalAlign: properties.verticalAlign
                  }}
                />
              </ConditionalLink>
            </td>
            <td
              width={getRatio(properties.columnRatio, "right")}
              style={{ verticalAlign: "middle" }}
            >
              <LiteSlateEditor block_id={children[0].block_id} />
            </td>
          </tr>
        </tbody>
      </table>
      <style>{styles}</style>
    </div>
  )
}
